import type { Step as RcStep } from '@sb/remote-control/types';

import { type ValidationRule } from '../../types';
import { ActionRequiredError } from '../../util/errors';

import { CanonicalStepRuleBase } from './base';
import type { CanonicalValidateArgs } from './base';

class OperateEquipmentRule extends CanonicalStepRuleBase {
  public constructor() {
    super('steps.OperateEquipment', 'OperateEquipment');
  }

  protected validate({ args }: CanonicalValidateArgs): void {
    type OEArgs = Extract<
      RcStep.Arguments,
      { argumentKind: 'OperateEquipment' }
    >;
    const a = args as OEArgs;
    this.checkEquipment(a);
    this.checkAction(a);
  }

  /**
   * Ensure an equipment selection is present.
   * Throws ActionRequiredError if missing.
   *
   * @throws {ActionRequiredError}
   */
  private checkEquipment(
    args: Extract<RcStep.Arguments, { argumentKind: 'OperateEquipment' }>,
  ): void {
    if (args.equipment == null) {
      throw new ActionRequiredError({
        kind: 'invalidConfiguration',
        message: 'Equipment required',
        fieldId: 'equipment',
      });
    }
  }

  /**
   * Ensure an action is selected.
   * Throws ActionRequiredError if missing.
   *
   * @throws {ActionRequiredError}
   */
  private checkAction(
    args: Extract<RcStep.Arguments, { argumentKind: 'OperateEquipment' }>,
  ): void {
    if (args.action == null) {
      throw new ActionRequiredError({
        kind: 'invalidConfiguration',
        message: 'Action required',
        fieldId: 'action',
      });
    }
  }
}

export const OperateEquipmentValidation: ValidationRule =
  new OperateEquipmentRule().toValidationRule();
